import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import basic from './modules/basic'
import addons from './modules/addons'
import company from './modules/company'
import address from './modules/address'
import options from './modules/options'
import socials from './modules/socials'
import projects from './modules/projects'
import template from './modules/template'
import attributes from './modules/attributes'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    basic,
    addons,
    company,
    address,
    options,
    socials,
    projects,
    template,
    attributes
  }
})
